export const REGISTER_EVENT = `
    mutation register_event($data: RegisterEventRequest!) {
      register_event(params: $data) {
        message
      }
    }
  `;
